import Request from './type/Request';

type PreJsonRequest = Omit<Request, 'body'> & {
    body?: Record<string, unknown>;
};

type T = (request: PreJsonRequest) => Request;

const f: T = (request) => ({
    method: request.method,
    body: request.body ? JSON.stringify(request.body) : undefined,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(request?.headers as Record<string, string>),
    },
});

export default f;
